import type { ReactElement } from 'react'

import { IR_FINANCIAL_ROUTE } from '@/utils/enroutes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

export const FinancialPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Financial Information"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_FINANCIAL_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...rest }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              forceReload={path === '/en/ir/financial/chart/'}
              {...rest}
              key={path}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}

FinancialPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Financial Information', path: '' },
  ]

  return (
    <>
      <Head
        title="Financial Information"
        description="Financial Information"
        ogp={{ url: 'en/ir/financial' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
